var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "paper-con" }, [
    _vm.$route.name === "technicalQAHistoryGuoJiao" ||
    _vm.$route.name === "technicalQAHistory"
      ? _c(
          "h3",
          {
            style: {
              top:
                _vm.$route.name === "technicalQAHistoryGuoJiao" ? "0" : "80px",
            },
          },
          [_vm._v("参考文献")]
        )
      : _vm._e(),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "paper-list",
      },
      _vm._l(_vm.paperListData, function (ref, idx) {
        return _c("div", { key: idx, staticClass: "paper-item" }, [
          _c("p", { staticClass: "title" }, [
            _c("span", [_vm._v(_vm._s(idx) + ". ")]),
            _c(
              "a",
              {
                on: {
                  click: function ($event) {
                    return _vm.toPaperDetails(ref.title, ref.url)
                  },
                },
              },
              [_vm._v(_vm._s(ref.title))]
            ),
            ref.pdf
              ? _c("img", {
                  attrs: {
                    src: require("@/assets/images/common/PDF.png"),
                    alt: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.toPdf(ref.pdf)
                    },
                  },
                })
              : _vm._e(),
          ]),
          _c("p", { staticClass: "text", attrs: { title: ref.text } }, [
            _vm._v(_vm._s(ref.text)),
          ]),
          _c(
            "p",
            { staticClass: "author" },
            [
              _c("span", [_vm._v("作者：")]),
              _vm._l(ref.authors, function (author, i) {
                return _c("span", { key: i }, [
                  _vm._v(_vm._s(author.name) + "；"),
                ])
              }),
            ],
            2
          ),
          _c("p", { staticClass: "year" }, [
            _c("span", [_vm._v(_vm._s(ref.year))]),
            _c("span", [_vm._v(_vm._s(ref.venue))]),
          ]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }